import React from 'react';

import { MCButton, SearchTextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import JourneyTimeline from 'src/components/timeline/JourneyTimeline';
import CreateJourney from 'src/components/timeline/Journey/create';

import { PrivacySetting, popupModel } from 'src/components/complex';

import { lang, permissions, remCss, withRouter } from 'src/helpers';

import model from './model';
import AlertManager from 'src/components/alert/AlertManager';
import LANG_CONST from 'src/helpers/lang/const';

const { PAGES, ACTIONS } = permissions;

class Journey extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    // listJourney, journeyUpdate and accountSwitched are handled by JourneyTimeline
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.router.params.journeyId !== this.props.router.params.journeyId) {
      this.selectJourneyId(this.props.router.params.journeyId);
    }
  }

  onJourneyReady = () => {
    model.handleChangeSearch('');
    this.selectJourneyId(this.props.router.params.journeyId);
  };

  onJourneyUpdate = () => {
    const { journeyId } = model.state;
    this.selectJourneyId(journeyId, !model.state.journeys.find((item) => item.id === journeyId));
  };

  selectJourneyId = (journeyId, refresh = true) => {
    this.setState({ loading: true });
    let journey = model.state.journeys.find((item) => item.id == journeyId);
    if (journeyId === 'timeline') {
      journey = { id: 'timeline' };
    }
    model.handleChangeSearch('');
    if (!journey) {
      this.navigate(PAGES.JOURNEY_PAGE.match('timeline'));
      this.setState({ loading: false });
    } else {
      model.setState({ journeyId: journeyId, journey });
      refresh && model.refreshRecent();
      setTimeout(() => {
        this.setState({ loading: false });
      }, 1000);
    }
  };

  selectJourney = (journey) => {
    this.setState({ loading: true });
    this.navigate(PAGES.JOURNEY_PAGE.match(journey.id));
  };

  render() {
    const { user: auth, journeyId, journey } = model.state;

    return (
      <div className={'mc-container-content mc-journey'}>
        {journeyId === 'timeline' ? (
          <div className={'mc-container-content__header mc-flex-15'}>
            <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.diary)}</span>
            <SearchTextField
              template={'2'}
              width={remCss(300)}
              placeholder={LANG_CONST.search}
              onChange={(search) => model.handleChangeSearch(search)}
              value={model.listInput('search')}
            />
            {ACTIONS.JOURNEY_ADD_BUTTON.isActive && (
              <div className={'mc-flex-col'}>
                <MCButton
                  medium
                  primary
                  dark
                  radius
                  flex
                  onClick={() => {
                    popupModel.setActivePopup(ACTIONS.JOURNEY_ADD_BUTTON.key, {
                      active: true,
                      component: CreateJourney,
                      props: { model }
                    });
                  }}
                >
                  {lang.t(LANG_CONST.buttons.new_diary)}
                </MCButton>
              </div>
            )}
          </div>
        ) : (
          <div className={'mc-container-content__header mc-flex-15'}>
            <MCButton onClick={() => this.navigate(-1)} width={40} iconname={'back-icon'} />
            <span className={'mc-grow'}>{journey?.title}</span>
            {auth.id === journey?.userId && (
              <>
                <PrivacySetting
                  title={'Can view Diary'}
                  buttonProps={{
                    dark: true,
                    primary: true,
                    light: false,
                    style: { height: remCss(30) }
                  }}
                  onChange={(privacySettings) => {
                    model.updatePrivacySettingsJourney({
                      id: journeyId,
                      privacySettings
                    });
                  }}
                  data={journey?.privacySettings}
                />
                <MCButton
                  style={{ height: remCss(50) }}
                  secondary
                  medium
                  radius
                  dark
                  onClick={() => {
                    AlertManager.popup(AlertManager.TYPES.WARN, {
                      title: LANG_CONST.notice.delete,
                      close: false,
                      cancelButton: {
                        label: LANG_CONST.buttons.no,
                        action: (actions) => actions.hide()
                      },
                      actionButton: {
                        label: LANG_CONST.buttons.yes,
                        action: (actions) => {
                          actions.setLoading(true);
                          model.removeJourney({
                            id: journeyId,
                            cb: () => {
                              actions.setLoading(false);
                              actions.hide();
                              this.navigate(-1);
                            }
                          });
                        }
                      }
                    });
                  }}
                >
                  {lang.t(LANG_CONST.buttons.remove_diary)}
                </MCButton>
              </>
            )}
          </div>
        )}
        <div className={' mc-container-content__body mc-p20'}>
          <JourneyTimeline
            model={model}
            loading={this.state.loading}
            onReady={this.onJourneyReady}
            onSelectJourney={this.selectJourney}
            onJourneyUpdate={this.onJourneyUpdate}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(Journey);
